import React from 'react';
import PropTypes from 'prop-types';
import { Form, Checkbox } from 'antd';
import { translate } from 'react-i18next';
import i18next from 'i18next';

import FundkyCollapse from 'Parts/ui/components/FundkyCollapse';
import FundkyTooltip from 'Parts/ui/components/FundkyTooltip.jsx';

import TaxReceiptField_en from './locales/TaxReceiptField_en.json';
import TaxReceiptField_fr from './locales/TaxReceiptField_fr.json';

class TaxReceiptField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      taxReceiptFieldDisplay: props.taxReceiptFieldDisplay
    };

    i18next.addResourceBundle('en', 'TaxReceiptField', TaxReceiptField_en);
    i18next.addResourceBundle('fr', 'TaxReceiptField', TaxReceiptField_fr);
  }

  componentDidUpdate(prevProps) {
    if (this.props.taxReceiptFieldDisplay !== prevProps.taxReceiptFieldDisplay)
      this.setState({
        taxReceiptFieldDisplay: this.props.taxReceiptFieldDisplay
      });
  }

  render() {
    const { props, state } = this,
      { t, form, className, savedValue, monthly } = props,
      { taxReceiptFieldDisplay } = state,
      { getFieldDecorator } = form;

    const input = (
      <Checkbox>
        {t('label')}&nbsp;
        <FundkyTooltip title={t('tooltip')} />
      </Checkbox>
    );
    const fieldId = 'taxReceipt';
    const fieldOptions = {
      normalize: value => value || false, // Return false instead of undefined
      valuePropName: 'checked',
      initialValue: savedValue
    };

    return (
      <FundkyCollapse isOpened={(taxReceiptFieldDisplay && !monthly) || false}>
        <Form.Item className={`${className} TaxReceipt__Checkbox`}>
          {getFieldDecorator(fieldId, fieldOptions)(input)}
        </Form.Item>
      </FundkyCollapse>
    );
  }
}

TaxReceiptField.propTypes = {
  form: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired
};

export default translate('TaxReceiptField')(TaxReceiptField);
